// @flow
import * as React from 'react'
import IconChevronLeft from './IconChevronLeft'

export default function withBackButton (Icon: React.ComponentType<any>) {
  return class WithBackButton extends React.Component<{url: string}> {
    render () {
      return (
        <a
          href={this.props.url}
          style={{display: 'flex', alignItems: 'center'}}
        >
          <IconChevronLeft width='16px' height='16px' />
          <Icon />
        </a>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/icons/WithBackButton.js